import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DemoApp from './DemoApp';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

// ── iOS Safari 버튼 미반응 보조 수정 (전역) ──
// touchmove 핸들러가 preventDefault 하면 버튼 위 손가락 미세이동 시 click 이 억눌릴 수 있어,
// 버튼/링크 위 touchmove 는 캡처 단계에서 전파를 끊어 하위 핸들러가 preventDefault 하지 못하게 한다.
if (typeof document !== 'undefined') {
  document.addEventListener('touchmove', (e) => {
    try {
      const t = e.target;
      if (t && t.closest && t.closest('button, a, [role="button"], label, .cart-bottom-button, .bottom-button, .options-bottom-button')) {
        e.stopPropagation();
      }
    } catch (_) { /* noop */ }
  }, { capture: true, passive: true });
}

// REACT_APP_BUILD_TARGET=demo 로 빌드하면 데모 전용 앱(/start)만 렌더 → 메인 서비스와 별도 번들
const isDemoBuild = process.env.REACT_APP_BUILD_TARGET === 'demo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isDemoBuild ? <DemoApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
